import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

export const LanguageSwitcher = ({ variant = 'light' }) => {
  const { language, setLang } = useLanguage();

  const isLight = variant === 'light';
  
  return (
    <div 
      data-testid="language-switcher"
      className="flex items-center gap-1 text-sm font-medium"
    >
      <motion.button
        onClick={() => setLang('pt')}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        data-testid="lang-pt"
        className={`px-2 py-1 rounded-md transition-colors duration-200 ${
          language === 'pt'
            ? isLight 
              ? 'text-[#ff00c7] bg-[#ff00c7]/10' 
              : 'text-[#ff00c7] bg-[#ff00c7]/20'
            : isLight
              ? 'text-[#242328]/60 hover:text-[#242328]'
              : 'text-[#f8f6e2]/60 hover:text-[#f8f6e2]'
        }`}
      >
        PT
      </motion.button>
      
      <span className={isLight ? 'text-[#242328]/30' : 'text-[#f8f6e2]/30'}>|</span>
      
      <motion.button
        onClick={() => setLang('en')}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        data-testid="lang-en"
        className={`px-2 py-1 rounded-md transition-colors duration-200 ${
          language === 'en'
            ? isLight 
              ? 'text-[#ff00c7] bg-[#ff00c7]/10' 
              : 'text-[#ff00c7] bg-[#ff00c7]/20'
            : isLight
              ? 'text-[#242328]/60 hover:text-[#242328]'
              : 'text-[#f8f6e2]/60 hover:text-[#f8f6e2]'
        }`}
      >
        EN
      </motion.button>
    </div>
  );
};
